import {ComponentFactoryResolver, ComponentRef, Injectable, Injector} from "@angular/core";
import {MessageToastType} from "./MessageToastType";
import {IMessageToastParams} from "./IMessageToastParams";
import {NModernToasterComponent} from "./components/n-modern-toaster.component";
import {ToastInstance} from "./ToastInstance";

@Injectable({providedIn: "root"})
export class ToastService {
  private container: ComponentRef<NModernToasterComponent>;

  constructor(private injector: Injector,
              private resolver: ComponentFactoryResolver) {
    const factory = this.resolver.resolveComponentFactory(NModernToasterComponent);
    this.container = factory.create(this.injector);
    document.body.appendChild(this.container.location.nativeElement);
  }

  getOpenedToasts(type?: MessageToastType): ToastInstance[] {
    return this.container.instance.toasts
      .filter(i => type ? i.type === type : true)
      .map(t => t.instance);
  }

  showInfo(text: string): ToastInstance {
    return this.showMessage(text, MessageToastType.INFO);
  }
  showCancel(text: string, onCancel?: () => void, onShowMore?: () => void): ToastInstance {
    return this.showMessage(text, MessageToastType.CANCELABLE, null, null, onCancel, onShowMore);
  }
  showError(text: string, uniqueId?: string, emergencyLink?: string): ToastInstance {
    return this.showMessage(text, MessageToastType.ERROR, uniqueId, emergencyLink);
  }

  private showMessage(text: string,
                      type: MessageToastType,
                      uniqueId?: string,
                      emergencyLink?: string,
                      onCancel?: () => void,
                      onShowMore?: () => void): ToastInstance {
    const p: IMessageToastParams = {
      type: type,
      text: text,
      uniqueId,
      emergencyLink,
      onCancel: onCancel || function() {},
      onShowMore
    };
    return this.container.instance.showToast(p);
  }
}
